import React, { useEffect, useState, useLayoutEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../components/Header";
import HeaderStepPractice from "../components/HeaderStepPractice";
import BoxButton from "../components/BoxButton";
import IncaricoComponent from "../components/Practice/IncaricoComponent";
import ClienteComponent from "../components/Practice/ClientComponent";
import CompensationComponent from "../components/Practice/CompensationComponent";
import AMLComponent from "../components/Practice/AMLComponent";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions, service } from "../model";
import axios from "axios";
import {
  validationPracticeStepOne,
  validationPracticeStepTwo,
  validationPracticeStepTree,
  validationPracticeStepFour,
} from "../utils/validation";
import PopupError from "../components/Generics/PopupError";
import SummaryPractice from "../components/Practice/summaryPractice";
import { Modal } from "@mui/material";
import ModalConferma from "../components/Generics/ModalConferma";
import ModalSuccess from "../components/Generics/ModalSuccess";
import { CircularProgress } from "@mui/material";
import ModalError from "../components/Generics/ModalError";

const Practice = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const containerRef = useRef(null);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const practices = useSelector(
    (state) => state.user?.redux_object?.practices || []
  );

  const reduxObject = JSON.parse(localStorage.getItem("redux_object") || "{}");

  const userId = `${reduxObject?.user?.id || ""}`;

  const [isInitializing, setIsInitializing] = useState(true);
  const [currentStep, setCurrentStep] = useState(1);

  const handlePrevious = () =>
    setCurrentStep((prev) => Math.max(prev - 1, 1), setErrorFileLarge(null));
  const [practice, setPractices] = useState(null);
  const [practice_object, setPractices_object] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [documentAssignment, setDocumentAssignment] = useState(false);
  const [documentPractice, setDocumentPractice] = useState([]);
  const [documentPracticeClient, setDocumentPracticeClient] = useState([]);
  const [idPractice, setIdPractice] = useState(id || null);
  const [successSend, setSuccessSend] = useState(false);
  const [errorSend, setErrorSend] = useState(false);
  const [resetPractice, setResetPractice] = useState(false);
  const [deletePractice, setDeletePractice] = useState(false);
  const [errorFileLarge, setErrorFileLarge] = useState(null);

  // state per diversa visualizzazione box button
  const [viewBoxButton, setViewBoxButton] = useState(false);

  // popup error validazione
  const [error, setError] = useState(false);
  // array errori
  const [fieldErrors, setFieldErrors] = useState([]);

  const [modalOpen, setModalOpen] = useState(false);

  const handleModalClick = (objectInfo) => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleCloseSuccessSendModal = () => {
    setSuccessSend(false);
    window.location.href = "/";
  };

  const handleCloseErrorSendModal = () => {
    setErrorSend(false);
    setCurrentStep(5);
  };

  const handleCloseResetPracticeModal = () => {
    setResetPractice(false);
  };

  useEffect(() => {
    if (id && practices.length > 0) {
      const practiceElement = practices.find(
        (practice) => practice.id === parseInt(id, 10)
      );

      setPractices_object(practiceElement);

      // Imposta lo step corretto
      if (
        practiceElement?.status === "sent" ||
        practiceElement?.practice_worked === 1
      ) {
        setCurrentStep(5);
      } else {
        setCurrentStep(practiceElement?.step || 1);
      }

      // Parsing documenti step 1
      let parsedData = { files: [] };
      if (practiceElement?.original_name_attached) {
        try {
          parsedData = JSON.parse(practiceElement.original_name_attached);
        } catch (err) {
          console.error("Errore", err);
        }
      }
      const filesArray = parsedData?.files
        ? Object.values(parsedData.files)
        : [];
      setDocumentPractice(filesArray);

      // Parsing documenti step 2
      let parsedDataClient = { files: [] };
      if (practiceElement?.new_customer_attached_np) {
        try {
          parsedDataClient = JSON.parse(
            practiceElement.new_customer_attached_np
          );
        } catch (err) {
          console.error("Errore", err);
        }
      }
      const filesArrayClient = parsedDataClient?.files
        ? Object.values(parsedDataClient.files)
        : [];
      setDocumentPracticeClient(filesArrayClient);

      // Imposta documentAssignment se ci sono file validi
      if (practiceElement?.original_name_attached) {
        try {
          const parsedFiles = JSON.parse(
            practiceElement.original_name_attached
          );
          if (Array.isArray(parsedFiles.files)) {
            const hasValidFile = parsedFiles.files.some(
              (file) => file.original_name_attached
            );
            if (hasValidFile) setDocumentAssignment(true);
          }
        } catch (err) {
          console.error("Errore", err);
        }
      }

      // Parsing practice interno
      if (practiceElement?.practice) {
        try {
          let parsedPractice = practiceElement.practice;
          while (typeof parsedPractice === "string") {
            parsedPractice = JSON.parse(parsedPractice);
          }
          const { 0: _, 1: __, ...cleanedPractice } = parsedPractice;
          setPractices(cleanedPractice);
        } catch (error) {
          console.error("Errore", error);
        }
      }

      // Fine inizializzazione
      setIsInitializing(false);
      setIsLoading(false);
    }
  }, [id, practices]);

  useEffect(() => {
    dispatch(actions.getPractice());
  }, []);

  const handlePracticeUpdate = (updatedAssignment) => {
    setPractices(updatedAssignment);
  };

  let AML = JSON.parse(localStorage.getItem("AML"));

  const handleNext = async () => {
    if (currentStep === 1) {
      const errors = validationPracticeStepOne(practice, documentAssignment);

      if (errors.length === 0 && documentAssignment) {
        if (viewBoxButton) {
          if (Object.keys(practice.AML).length === 0) {
            setCurrentStep((prev) => Math.min(prev + 3, 5));
          } else {
            setCurrentStep((prev) => Math.min(prev + 4, 5));
          }
          if (currentStep === 5) {
            await savePractice();
          }
          setViewBoxButton(false);
          setErrorFileLarge(null);
        } else {
          await savePractice();
          setCurrentStep((prev) => Math.min(prev + 1, 4));
          setErrorFileLarge(null);
        }
        setFieldErrors([]);
      } else {
        setError(true);
        setTimeout(() => setError(false), 5000);
        setFieldErrors(errors);
        setCurrentStep(1);
      }
    } else if (currentStep === 2) {
      const errors = validationPracticeStepTwo(practice);

      if (errors.length === 0) {
        if (viewBoxButton) {
          setCurrentStep((prev) => Math.min(prev + 3, 5));
          if (currentStep === 5) {
            await savePractice();
          }
          setViewBoxButton(false);
        } else {
          await savePractice();
          setCurrentStep((prev) => Math.min(prev + 1, 4));
        }
        setFieldErrors([]);
      } else {
        setError(true);
        setTimeout(() => setError(false), 5000);
        setFieldErrors(errors);
        setCurrentStep(2);
      }
    } else if (currentStep === 3) {
      const errors = validationPracticeStepTree(practice);

      if (errors.length === 0) {
        if (viewBoxButton) {
          setCurrentStep((prev) => Math.min(prev + 2, 5));
          if (currentStep === 5) {
            await savePractice();
          }
          setViewBoxButton(false);
        } else {
          await savePractice();
          setCurrentStep((prev) => Math.min(prev + 1, 4));
        }
        setFieldErrors([]);
      } else {
        setError(true);
        setTimeout(() => setError(false), 5000);
        setFieldErrors(errors);
        setCurrentStep(3);
      }
    } else if (currentStep === 4) {
      const errors = validationPracticeStepFour(practice);

      if (errors.length === 0) {
        if (viewBoxButton) {
          setCurrentStep((prev) => Math.min(prev + 1, 5));
          if (currentStep === 5) {
            await savePractice();
          }
          setViewBoxButton(false);
        } else {
          await savePractice();
          setCurrentStep((prev) => Math.min(prev + 1, 5));
        }

        setFieldErrors([]);
      } else {
        setError(true);
        setTimeout(() => setError(false), 5000);
        setFieldErrors(errors);
        setCurrentStep(4);
      }
    } else if (currentStep === 5) {
      handleModalClick();
    } else {
      setCurrentStep((prev) => Math.min(prev + 1, 4));
      await savePractice();
    }
    actions.getPractice();
  };

  const uploadFiles = async (filesToUpload) => {
    setErrorFileLarge(null);
    const formData = new FormData();
    filesToUpload.forEach((file, index) => {
      formData.append(`attached[${index}]`, file);
    });

    const team_riferimento = practice?.Incarico?.Team_riferimento?.id
      ? `${practice?.Incarico?.Team_riferimento?.id}`
      : "1";

    if (idPractice) {
      await service.update(
        practice,
        idPractice,
        team_riferimento,
        userId,
        currentStep
      );
    }

    try {
      if (idPractice) {
        formData.append("practice_id", idPractice);
        const response = await axios.post(
          process.env.REACT_APP_API_ENDPOINT + "upload-file-practice",
          formData,
          {
            headers: {
              Authorization: `Bearer ${reduxObject.accessToken}`,
            },
          }
        );

        const parsedData = JSON.parse(response.data.original_name_attached);
        const filesArray = parsedData?.files
          ? Object.values(parsedData.files)
          : [];
        setDocumentPractice(filesArray);
        setDocumentAssignment(true);
        setErrorFileLarge(false);
      }
    } catch (error) {
      console.error("errore", error);
      if (error.response && error.response.status === 413) {
        setErrorFileLarge(true);
      }
    }
  };

  const savePractice = async () => {
    try {
      if (idPractice) {
        const readersEmail =
          Array.isArray(practice?.Incarico?.readers_email) &&
          practice.Incarico.readers_email.length === 0
            ? null
            : practice?.Incarico?.readers_email ?? null;

        await service.update(
          practice,
          idPractice,
          `${practice.Incarico.Team_riferimento.id}`,
          userId,
          currentStep + 1,
          readersEmail
        );
      }
      await dispatch(actions.getPractice());
    } catch (error) {
      console.error(error);
    }
  };

  const sendPractice = async () => {
    setModalOpen(false);
    setIsLoading(true);
    try {
      if (idPractice) {
        await service.send(idPractice);
        setTimeout(() => {
          setIsLoading(false);
          setSuccessSend(true);
        }, 3000);
      }
    } catch (error) {
      console.error(error);
      setErrorSend(true);
      setIsLoading(false);
    }
  };

  const removeFilePractice = async (fileToRemove, files) => {
    setErrorFileLarge(null);
    if (files.length === 0) {
      setDocumentAssignment(false);
    }

    await service.deleteDocument(idPractice, fileToRemove.id);

    const team_riferimento = practice?.Incarico?.Team_riferimento?.id
      ? `${practice?.Incarico?.Team_riferimento?.id}`
      : "1";

    await service.update(
      practice,
      idPractice,
      team_riferimento,
      userId,
      currentStep
    );
    await service.getPractice();
  };

  const closePopupError = () => {
    setError(false);
  };

  const goToStep = (step) => {
    setCurrentStep(step);
    setViewBoxButton(true);
  };

  const openModalResetPractice = () => {
    setResetPractice(true);
  };

  const startAgain = async () => {
    localStorage.setItem("AML", null);
    setResetPractice(false);
    setCurrentStep(1);
    setDocumentAssignment(false);

    const updatedAssignment = {
      Incarico: {},
      Cliente: {},
      Compensation: {},
      AML: {},
    };

    handlePracticeUpdate(updatedAssignment);

    const team_riferimento = practice?.Incarico?.Team_riferimento?.id
      ? `${practice?.Incarico?.Team_riferimento?.id}`
      : "1";

    await service.deleteDocument(idPractice);
    await service.update(
      updatedAssignment,
      idPractice,
      team_riferimento,
      userId,
      "1"
    );
    await dispatch(actions.getPractice());
  };

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [currentStep]);

  // upload doc step 2 cliente
  const uploadFilesClient = async (filesToUpload) => {
    setErrorFileLarge(null);
    const formData = new FormData();
    filesToUpload.forEach((file, index) => {
      formData.append(`attached[${index}]`, file);
    });

    try {
      if (idPractice) {
        formData.append("practice_id", idPractice);
        const response = await axios.post(
          process.env.REACT_APP_API_ENDPOINT + "upload-file-new-customer",
          formData,
          {
            headers: {
              Authorization: `Bearer ${reduxObject.accessToken}`,
            },
          }
        );

        const parsedData = JSON.parse(response.data.new_customer_attached_np);
        const filesArray = parsedData?.files
          ? Object.values(parsedData.files)
          : [];
        setDocumentPracticeClient(filesArray);
        setErrorFileLarge(false);
      }
    } catch (error) {
      console.error(error);
      if (error.response && error.response.status === 413) {
        setErrorFileLarge(true);
      }
    }
  };

  const removeFilePracticeClient = async (fileToRemove, files) => {
    setErrorFileLarge(null);

    await service.deleteDocumentClient(idPractice, fileToRemove.id);

    const team_riferimento = practice?.Incarico?.Team_riferimento?.id
      ? `${practice?.Incarico?.Team_riferimento?.id}`
      : "1";

    await service.update(
      practice,
      idPractice,
      team_riferimento,
      userId,
      currentStep
    );
    await service.getPractice();
  };

  if (isInitializing) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 2000,
        }}
      >
        <CircularProgress style={{ color: "#1b2838" }} />
      </div>
    );
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
        }}
      >
        <div
          style={{
            position: "fixed",
            top: 0,
            width: "100%",
            zIndex: 1000,
          }}
        >
          <Header />
          {practice_object?.status === "sent" || currentStep === 5 ? null : (
            <HeaderStepPractice
              currentStep={currentStep}
              steps={["Incarico", "Cliente", "Compenso", "AML"]}
            />
          )}
        </div>

        <div
          ref={containerRef}
          style={{
            flex: 1,
            overflowY: "auto",
            paddingTop:
              practice_object?.status === "sent" || currentStep === 5
                ? "100px"
                : "180px",
            paddingBottom: practice_object?.status === "sent" ? "30px" : "80px",
          }}
        >
          {currentStep === 1 ? (
            <IncaricoComponent
              errors={fieldErrors}
              uploadFiles={uploadFiles}
              documentAssignment={documentAssignment}
              removeFilePractice={removeFilePractice}
              practice={practice}
              onPracticeUpdate={handlePracticeUpdate}
              documentPractice={documentPractice}
              practice_object={practice_object}
              errorFileLarge={errorFileLarge}
            />
          ) : currentStep === 2 ? (
            <ClienteComponent
              uploadFilesClient={uploadFilesClient}
              errors={fieldErrors}
              handleClientUpdate={handlePracticeUpdate}
              practice={practice}
              documentPracticeClient={documentPracticeClient}
              removeFilePracticeClient={removeFilePracticeClient}
              errorFileLarge={errorFileLarge}
            />
          ) : currentStep === 3 ? (
            <CompensationComponent
              errors={fieldErrors}
              handleCompesoUpdate={handlePracticeUpdate}
              practice={practice}
            />
          ) : currentStep === 4 ? (
            <AMLComponent
              errors={fieldErrors}
              onPracticeUpdate={handlePracticeUpdate}
              practice={practice}
            />
          ) : currentStep === 5 ? (
            <SummaryPractice
              userId={userId}
              idPractice={idPractice}
              practice_object={practice_object}
              goToStep={goToStep}
              documentPractice={documentPractice}
              documentPracticeClient={documentPracticeClient}
              practice={practice}
            />
          ) : null}
        </div>

        {practice_object?.status === "sent" ? null : (
          <BoxButton
            viewBoxButton={viewBoxButton}
            currentStep={currentStep}
            onNext={handleNext}
            onPrevious={handlePrevious}
            startAgain={openModalResetPractice}
          />
        )}
      </div>

      {error && (
        <div
          style={{
            width: "350px",
            position: "fixed",
            bottom: "-15px",
            left: "50%",
            backgroundColor: "#fff",
            transform: "translate(-50%, -50%)",
            zIndex: 1000,
            padding: "12px 10px",
            borderRadius: "0px",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
            fontSize: "14px",
          }}
        >
          <PopupError
            copyError="Uno o più campi obbligatori sono mancanti"
            closePopupError={closePopupError}
          />
        </div>
      )}

      <Modal open={modalOpen} onClose={handleCloseModal}>
        <ModalConferma
          title="Conferma pratica"
          descriptionOne="Attenzione! L'invio è un'azione irreversibile con cui si inoltrano
          automaticamente i dati all'amministrazione. Se invii dei dati errati,
          dovrai contattare direttamente l'amministrazione per impedire l'apertura
          della pratica."
          descriptionTwo="Sei sicuro di voler procedere?"
          copyButton="Sì, invia"
          confirm={sendPractice}
          onClose={handleCloseModal}
        />
      </Modal>

      {successSend && (
        <Modal open={true} onClose={handleCloseSuccessSendModal}>
          <ModalSuccess
            title="Invio effettuato con successo"
            descriptionOne="La tua richiesta di apertura pratica è stata inoltrata all'amministrazione."
            descriptionTwo="Riceverai una e-mail non appena la tua richiesta sarà approvata."
            copyButton="Chiudi"
            confirm={handleCloseSuccessSendModal}
            onClose={handleCloseSuccessSendModal}
          />
        </Modal>
      )}

      {errorSend && (
        <Modal open={errorSend} onClose={handleCloseErrorSendModal}>
          <ModalError
            title="Invio non effettuato"
            descriptionOne="La tua richiesta di apertura pratica non può essere inoltrata a causa di un momentaneo errore tecnico."
            descriptionTwo="Ti invitiamo a riprovare tra qualche minuto."
            copyButton="Chiudi"
            confirm={handleCloseErrorSendModal}
            onClose={handleCloseErrorSendModal}
          />
        </Modal>
      )}

      {resetPractice && (
        <Modal open={resetPractice} onClose={handleCloseResetPracticeModal}>
          <ModalError
            modalInfo={true}
            title="Azzera dati"
            descriptionOne="Attenzione! L'azzeramento dei dati è un'azione irreversibile con cui vengono cancellati definitivamente tutti i progressi della bozza."
            descriptionTwo="Sei sicuro di voler procedere?"
            copyButton="Sì, azzera"
            confirm={startAgain}
            onClose={handleCloseResetPracticeModal}
          />
        </Modal>
      )}

      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <CircularProgress style={{ color: "#1b2838" }} />
        </div>
      )}
    </>
  );
};

export default Practice;
